import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.2263 3C7.25576 3 3.22632 7.02944 3.22632 12C3.22632 16.9706 7.25576 21 12.2263 21C15.9153 21 19.0882 18.7803 20.4779 15.5996L22.3106 16.4004C20.6141 20.2833 16.7386 23 12.2263 23C6.15119 23 1.22632 18.0751 1.22632 12C1.22632 5.92487 6.15119 1 12.2263 1C18.3015 1 23.2263 5.92487 23.2263 12V14L19.6263 11.3L20.8263 9.7L20.9545 9.79616C19.9716 5.891 16.4366 3 12.2263 3ZM12.2263 8.5C12.9167 8.5 13.4763 9.05964 13.4763 9.75V10.5H10.9763V9.75C10.9763 9.05964 11.536 8.5 12.2263 8.5ZM15.4763 10.5V9.75C15.4763 7.95508 14.0212 6.5 12.2263 6.5C10.4314 6.5 8.97632 7.95507 8.97632 9.75V10.5H7.72485V17H16.7249V10.5H15.4763Z"}}]};

const RotateLockedFilled = Vue.extend<IconProps>({
  name: 'RotateLockedFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'rotate-locked-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default RotateLockedFilled;
